import Image from "next/image";
import Link from "next/link";

import { useEffect, useState } from "react";

// import blogData from "../../data/blog/blog.json";
import BlogGridTop from "./Blog-Sections/BlogGrid-Top";
import Pagination from "../Common/Pagination";
import GoogleAdLarge from "../Ads/GoogleAdLarge";

const BlogGrid = ({ blogType, blogData, isPagination, top, start, end }) => {
  console.log(blogData)
  const ITEMS_PER_PAGE = 10

  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  // const selectedGridBlogs = blogs.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const selectedGridBlogs = blogData.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setBlogs(blogData);
    setTotalPages(Math.ceil(blogData.length / ITEMS_PER_PAGE));
  }, [setTotalPages, setBlogs]);
  return (
    <>
      {top ? (
        <BlogGridTop
          blogData={blogData}
          selectedGridBlogs={selectedGridBlogs}
        />
      ) : (
        ""
      )}

      <div className="row g-5 mt--15">
        {blogData &&
          selectedGridBlogs.slice(start, end).map((data, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={index}>
              <div className="rbt-card variation-02 rbt-hover">
                <div className="rbt-card-img">
                  <Link href={`/${blogType}/${data.content_id}`}>
                    <Image
                      src={data.image.thumbnail}
                      width={450}
                      height={267}
                      priority
                      alt="Card image"
                    />{" "}
                  </Link>
                </div>
                <div className="rbt-card-body">
                  <h5 className="rbt-card-title">
                    <Link href={`/${blogType}/${data.content_id}`}>{data.title}</Link>
                  </h5>
                  <p className="rbt-card-text">{data?.desc}</p>
                  <div className="rbt-card-bottom">
                    <Link
                      className="transparent-button"
                      href={`/${blogType}/${data.content_id}`}
                    >
                      Read Article
                      <i>
                        {" "}
                        <svg
                          width="17"
                          height="12"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g stroke="#27374D" fill="none" fillRule="evenodd">
                            <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                            <path
                              strokeLinecap="square"
                              d="M.663 5.572h14.594"
                            />
                          </g>
                        </svg>
                      </i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <GoogleAdLarge />
      </div>

      {isPagination ? (
        <div className="row">
          <div className="col-lg-12 mt--60">
            <Pagination
              totalPages={totalPages}
              pageNumber={page}
              handleClick={handleClick}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default BlogGrid;
